import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';

class PaginationComponent {
    constructor() {
        this.numberOfPages = 0;
        this.pageLinkSize = 5;
        this.highLight = false;
        this.hiddenOnlyPages = false;
        this.pageSize = 20;
        this.totalItens = 0;
        this.elementsOnThePage = 0;
        this.onPageChange = new EventEmitter();
        this.pageNumbers = [];
        this.pageSizes = [5, 10, 15, 20, 30, 40, 50, 100, 999];
        this.currentPage = 1;
        this.allowShowAllItens = false;
    }
    ngOnChanges() {
        this.loadPageNumbers(this.currentPage);
    }
    first(event) {
        this.onChangePageNumber(1, event);
    }
    previous(event) {
        event.preventDefault();
        if (this.canGoPrevious()) {
            this.onChangePageNumber(this.currentPage - 1, event);
        }
    }
    next(event) {
        event.preventDefault();
        if (this.canGoNext()) {
            this.onChangePageNumber(this.currentPage + 1, event);
        }
    }
    last(event) {
        this.onChangePageNumber(this.numberOfPages, event);
    }
    onChangePageSize(value) {
        this.pageSize = value;
        this.currentPage = 1;
        this.emitOnPageChange();
    }
    onChangePageNumber(newCurrentPage, event) {
        event.preventDefault();
        if (this.currentPage !== newCurrentPage) {
            this.loadPageNumbers(newCurrentPage);
            this.currentPage = newCurrentPage;
            this.emitOnPageChange();
        }
    }
    firstElementerOfPage() {
        return this.baseCalculo() + 1;
    }
    lastElementerOfPage() {
        return this.baseCalculo() + this.elementsOnThePage;
    }
    baseCalculo() {
        return ((this.currentPage - 1) * this.pageSize);
    }
    emitOnPageChange() {
        this.onPageChange.emit([this.currentPage, this.pageSize]);
    }
    loadPageNumbers(pageToGo) {
        if (this.pageLinkSize < 3) {
            this.pageLinkSize = 3;
        }
        this.pageNumbers = [];
        const FIRST_PAGE = 1;
        let start = Math.max(FIRST_PAGE, Math.ceil(pageToGo - (this.pageLinkSize / 2)));
        let end = Math.min(this.numberOfPages, (start + this.pageLinkSize - 1));
        if (this.isLastPage(end)) {
            start = Math.max(FIRST_PAGE, end - this.pageLinkSize + 1);
        }
        this.pageNumbers = [];
        for (let i = start; i <= end; i++) {
            this.pageNumbers.push(i);
        }
    }
    isLastPage(end) {
        return end === this.numberOfPages;
    }
    canGoPrevious() {
        return this.currentPage > 1;
    }
    canGoNext() {
        return this.currentPage < this.numberOfPages;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PaginationComponent, isStandalone: true, selector: "elo-pagination", inputs: { numberOfPages: "numberOfPages", pageLinkSize: "pageLinkSize", highLight: "highLight", hiddenOnlyPages: "hiddenOnlyPages", pageSize: "pageSize", totalItens: "totalItens", elementsOnThePage: "elementsOnThePage", pageSizes: "pageSizes", currentPage: "currentPage", allowShowAllItens: "allowShowAllItens" }, outputs: { onPageChange: "onPageChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"panel-pagination\">\n\n  <div class=\"sisters\">\n    <div class=\"number-itens\" *ngIf=\"!hiddenOnlyPages\">\n      <b> Mostrar </b>\n\n      <select id=\"pageSize\" name=\"pageSize\" [ngModel]=\"pageSize\" (ngModelChange)=\"onChangePageSize($event)\">\n        <option *ngIf=\"allowShowAllItens\" [ngValue]=\"9999\">Todos</option>\n        <option *ngFor=\"let c of pageSizes\" [ngValue]=\"c\">{{c}}</option>\n      </select>\n\n      <b> Itens </b>\n    </div> \n  </div>\n\n  <div class=\"sisters\">\n    <ul class=\"panel-pagination-inner\" *ngIf=\"!hiddenOnlyPages && pageSize !== 9999\">\n\n      <li class=\"page-item\" (click)=\"first($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-backward\"></span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"previous($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngFor=\"let p of pageNumbers\" [value]=\"p\" [class.active]=\"p === currentPage\"\n        (click)=\"onChangePageNumber(p,$event)\" class=\"page-item\"><a class=\"page-link\" href=\"#\">{{p}}</a></li>\n\n      <li class=\"page-item\" (click)=\"next($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"last($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-forward\"></span>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"sisters\" *ngIf=\"highLight\">\n    <div class=\"highLight\">\n      {{firstElementerOfPage()}} - {{lastElementerOfPage()}} de {{totalItens}}\n    </div>\n  </div>\n</div>", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-pagination', imports: [
                        CommonModule, FormsModule
                    ], standalone: true, template: "<div class=\"panel-pagination\">\n\n  <div class=\"sisters\">\n    <div class=\"number-itens\" *ngIf=\"!hiddenOnlyPages\">\n      <b> Mostrar </b>\n\n      <select id=\"pageSize\" name=\"pageSize\" [ngModel]=\"pageSize\" (ngModelChange)=\"onChangePageSize($event)\">\n        <option *ngIf=\"allowShowAllItens\" [ngValue]=\"9999\">Todos</option>\n        <option *ngFor=\"let c of pageSizes\" [ngValue]=\"c\">{{c}}</option>\n      </select>\n\n      <b> Itens </b>\n    </div> \n  </div>\n\n  <div class=\"sisters\">\n    <ul class=\"panel-pagination-inner\" *ngIf=\"!hiddenOnlyPages && pageSize !== 9999\">\n\n      <li class=\"page-item\" (click)=\"first($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-backward\"></span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"previous($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">&laquo;</span>\n        </a>\n      </li>\n\n      <li *ngFor=\"let p of pageNumbers\" [value]=\"p\" [class.active]=\"p === currentPage\"\n        (click)=\"onChangePageNumber(p,$event)\" class=\"page-item\"><a class=\"page-link\" href=\"#\">{{p}}</a></li>\n\n      <li class=\"page-item\" (click)=\"next($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">&raquo;</span>\n        </a>\n      </li>\n\n      <li class=\"page-item\" (click)=\"last($event)\">\n        <a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n          <span class=\"fa fa-step-forward\"></span>\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"sisters\" *ngIf=\"highLight\">\n    <div class=\"highLight\">\n      {{firstElementerOfPage()}} - {{lastElementerOfPage()}} de {{totalItens}}\n    </div>\n  </div>\n</div>" }]
        }], propDecorators: { numberOfPages: [{
                type: Input
            }], pageLinkSize: [{
                type: Input
            }], highLight: [{
                type: Input
            }], hiddenOnlyPages: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], totalItens: [{
                type: Input
            }], elementsOnThePage: [{
                type: Input
            }], onPageChange: [{
                type: Output
            }], pageSizes: [{
                type: Input
            }], currentPage: [{
                type: Input
            }], allowShowAllItens: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { PaginationComponent };
